import { translateDay } from 'features/schedule/utils';
import type { DayOfWeek } from 'services/api';

export const modalColumnsConfig = [
  {
    key: 'dayOfWeek',
    title: 'День недели',
    dataIndex: ['dayOfWeek'],
    render: (dayOfWeek: DayOfWeek) => translateDay(dayOfWeek),
  },
  {
    key: 'actualPercent',
    title: 'Фактический %',
    dataIndex: ['actualPercent'],
  },
  {
    key: 'expectedMinPercent',
    title: 'Мин.ожидаемый %',
    dataIndex: ['expectedMinPercent'],
  },
  {
    key: 'expectedMaxPercent',
    title: 'Макс.ожидаемый %',
    dataIndex: ['expectedMaxPercent'],
  },
  {
    key: 'deviationPercent',
    title: 'Откл. от ожидаемого %',
    dataIndex: ['deviationPercent'],
  },
];
